import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/users/Login'
import Logout from '@/components/users/Logout'
import Dashboard from '@/components/dashboard/HomePage'
import DashboardAdmin from '@/components/dashboard/admin/HomePage'
import PropertyList from '@/components/dashboard/property/List/Properties'
import DirectoryList from '@/components/dashboard/directory/list/Directories'
import PropertiesAnalytics from '@/components/dashboard/property/analytics/PropertyAnalytics'
import PropertiesEnquiries from '@/components/dashboard/property/enquiries/PropertyEnquiries'
import DirectoriesAnalytics from '@/components/dashboard/directory/analytics/DirectoriesAnalytics'
import DirectoriesEnquiries from '@/components/dashboard/directory/enquiries/DirectoryEnquiries'
import Advertise from '@/components/dashboard/advertise/Advertise'
import AdvertiseDir from '@/components/dashboard/advertise/AdvertiseDirectory'
import Invoicing from '@/components/dashboard/invoicing/Invoicing'
import DataFeed from '@/components/dashboard/dataFeed/DataFeed'
import XmlImportReport from '@/components/dashboard/xmlimport/Report'
import FAQ from '@/components/dashboard/faq/Faq'
import TermsOfService from '@/components/dashboard/termsofservice/TermsOfService'
import Support from '@/components/dashboard/support/Support'
import NotFound from '@/components/dashboard/common/NotFound'

import Cookie from 'js-cookie'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      data: {
        dashboard: false
      },
      meta: {
        title: 'Access Control',
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      data: {
        dashboard: false
      },
      meta: {
        title: 'Log Out Service',
      }
    },

    /* ADVERTISE */
    {
      path: '/advertise',
      name: 'Advertise',
      component: Advertise,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Advertise Property',
      },
    },

    /* ADVERTISE DIRECTORY */
    {
      path: '/advertise-directory',
      name: 'AdvertiseDir',
      component: AdvertiseDir,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Advertise Directory',
      },
    },
    {
      path: '/invoicing',
      name: 'Invoicing',
      component: Invoicing,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Invoicing',
      },
    },
    {
      path: '/termsofservice',
      name: 'TermsOfService',
      component: TermsOfService,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Terms of Service',
      },
    },

    /* DASHBOARD */
    /*{
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Dashboard',
      },
    },*/
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: '/admin',
      name: 'DashboardAdmin',
      component: DashboardAdmin,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Admin Dashboard',
      },
    },

    /* PROPERTIES */
    {
      path: '/properties',
      name: 'Properties',
      component: PropertyList,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Properties',
      },
    },
    {
      path: '/properties/featured',
      name: 'FeaturedProperties',
      component: PropertyList,
      data: {
        dashboard: true
      },

      meta: {
        title: 'Properties',
      },
    },
    {
      path: '/properties/analytics',
      name: 'PropertiesAnalytics',
      component: PropertiesAnalytics,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Properties Analytics',
      },
    },
    {
      path: '/properties/enquiries',
      name: 'PropertiesEnquiries',
      component: PropertiesEnquiries,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Properties Enquiries',
      },
    },
    {
      path: '/properties/data-feed',
      name: 'DataFeed',
      component: DataFeed,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Data Feed - XML Feeds',
      },
    },
    {
      path: '/properties/xml-import-report',
      name: 'XmlImportReport',
      component: XmlImportReport,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Xml Import Report',
      },
    },

    /* DIRECTORIES */
    {
      path: '/directories',
      name: 'Directories',
      component: DirectoryList,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Directories',
      },
    },
    {
      path: '/directories/analytics',
      name: 'DirectoriesAnalytics',
      component: DirectoriesAnalytics,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Directories Analytics',
      },
    },
    {
      path: '/directories/enquiries',
      name: 'DirectoriesEnquiries',
      component: DirectoriesEnquiries,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Directories Enquiries',
      },
    },

    /* SUPPORT */
    {
      path: '/support',
      name: 'Support',
      component: Support,
      data: {
        dashboard: true
      },
      meta: {
        title: 'Support',
      },
    },

    /* FAQ */
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ,
      data: {
        dashboard: true
      },
      meta: {
        title: 'FAQ',
      },
    },

    { path: '*',
      name: 'NotFound',
      component: NotFound,
      data: {
        dashboard: true
      },
      meta: {
        title: 'FAQ',
      },
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {

    if (to.path === from.path){
      return to
    }

    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.hash || from.hash) {
        /*
        return {
          selector: to.hash || from.hash,
          offset: { x: 0, y: 90 }
        }*/
        return {x: 0, y: 0};
      } else {
        return {x: 0, y: 0};
      }

    }
  }
})



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = null
// module chunks = 